// extracted by mini-css-extract-plugin
export var text = "_u-0";